import { FC } from 'react';
import { Button } from './styles';

interface PlacesItemProps {
	selectPlace: (placeId: number) => void;
	placeId: number;
	name: string;
	isSelected: boolean;
}

export const PlacesItem: FC<PlacesItemProps> = ({
	selectPlace,
	placeId,
	name,
	isSelected = false,
}) => {
	const select = () => {
		selectPlace(placeId);
	};

	return (
		<Button $isSelected={isSelected} onClick={!window.matchMedia("(pointer: coarse)").matches ? select : undefined} onTouchStart={select}>
			{name}
		</Button>
	);
};
